export const NVC_CASE_TYPE_MAP = {
  immigrant: 'NVC - IV',
  'non-immigrant': 'NVC - NIV',
} as const
